import { useEffect, useState } from 'react';

import { FormFieldSet } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';
import { useFormContext } from 'react-hook-form';

import { useVehiclesListSelectedQuery } from 'src/common/external/bambi-api/bambiApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { MultiSelectContextField } from 'src/common/FormField/MultiSelectContextField';
import { CoreFormFieldSwitch } from 'src/common/FormField/v2/core/CoreFormFieldSwitch';

export const PayerAuthorizedVehicleSettings = () => {
  const { setValue, watch } = useFormContext();
  const requiresVehicleAuthorization = watch('allow_only_specific_vehicles');
  const allowedVehicles = watch('allowed_vehicles');

  const [query, setQuery] = useState('');

  const {
    data: vehicles,
    isLoading,
    isFetching,
  } = useVehiclesListSelectedQuery({
    search: query,
    vehicleFilters: {
      selected_vehicles: allowedVehicles,
    },
    pageSize: 1000,
  });

  const vehicleOptions = vehicles?.results.map((v) => ({
    label: v.nickname || v.id,
    value: v.id,
  }));

  useEffect(() => {
    if (!requiresVehicleAuthorization) {
      setValue('allowed_vehicles', []);
    }
  }, [requiresVehicleAuthorization, setValue]);

  return (
    <div className="py-2">
      <FormFieldSet
        legend="Vehicle Authorizations"
        Fields={
          <>
            <FormFieldController name="allow_only_specific_vehicles">
              {({ field }) => {
                return (
                  <CoreFormFieldSwitch
                    colSpan={12}
                    label="Payer Requires Vehicle Authorization"
                    inputProps={{
                      value: field.value,
                      onChange: field.onChange,
                      id: 'allow_only_specific_vehicles',
                    }}
                  />
                );
              }}
            </FormFieldController>
            <div className="col-span-12">
              <MultiSelectContextField
                options={vehicleOptions || []}
                fieldPath="allowed_vehicles"
                label="Authorized Vehicles"
                disabled={
                  isLoading || isFetching || !requiresVehicleAuthorization
                }
                searchable
                query={query}
                setQuery={setQuery}
              />
            </div>
          </>
        }
      />
    </div>
  );
};
